module.exports = __webpack_public_path__ + "static/media/arrow_left_android.0bc6f3fa.svg";